


/**
 * requestIdleCallback 兼容方法
 * 如果浏览器不支持 requestIdleCallback，降级使用 setTimeout
 */
export const requestIdleCallbackCompat = (
  callback: IdleRequestCallback,
  options?: IdleRequestOptions,
): number => {
  if (typeof window === 'undefined') {
    return 0;
  }

  if ('requestIdleCallback' in window) {
    return window.requestIdleCallback(callback, options);
  }

  const start = performance.now();
  const timeout = options?.timeout ?? 50;
  let didTimeout = false;

  const invoke = () => {
    const deadline: IdleDeadline = {
      didTimeout,
      timeRemaining: () => Math.max(0, 50 - (performance.now() - start)),
    };
    callback(deadline);
  };

  const timerId = setTimeout(() => {
    didTimeout = true;
    invoke();
  }, timeout > 0 ? timeout : 1) as unknown as number;

  setTimeout(() => {
    if (!didTimeout) {
      clearTimeout(timerId);
      invoke();
    }
  }, 1);

  return timerId;
};



/**
 * cancelIdleCallback 兼容方法
 */
export const cancelIdleCallbackCompat = (handle: number): void => {
  if (typeof window === 'undefined') {
    return
  }
  if ('cancelIdleCallback' in window) {
    window.cancelIdleCallback(handle)
  } else {
    clearTimeout(handle)
  }
}
